import { Alert } from '@elementary/common-ui/components';
import { IntegrationError } from 'settings/types';

const IntegrationErrorAlert = ({ error }: { error: IntegrationError }) => {
  const { title, text } = error.integrationError
    ? { title: error.message, text: error.integrationError }
    : { title: undefined, text: error.message };

  return (
    <Alert severity="error" title={title}>
      <span>{text}</span>
    </Alert>
  );
};

export default IntegrationErrorAlert;
